import { useEffect } from 'react';
import useCustomer from 'hooks/useCustomer';
import useUser from 'hooks/useUser';
import useDataSource from 'hooks/useDataSource';

const isProd = process.env.NODE_ENV === 'production';

if (isProd) {
  /* eslint-disable */
  (function (apiKey) {
    (function (p, e, n, d, o) {
      let v; let w; let x; let y; let z; o = p[d] = p[d] || {}; o._q = o._q || [];
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w) {
        (function (m) {
          o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
        }(v[w]));
      }
      y = e.createElement(n); y.async = !0; y.src = `https://cdn.eu.pendo.io/agent/static/${apiKey}/pendo.js`;
      z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
    }(window, document, 'script', 'pendo'));
  }('47d8d66c-4fd8-4410-7fdc-e2baad9ecbd0'));
  /* eslint-enable */
} else {
  window.pendo = {
    initialize: (...args) => console.log('Pendo debug', ...args),
  };
}

const Pendo = () => {
  const { user } = useUser();
  const { customer, customerAccess } = useCustomer();
  const { dataSourceAccess } = useDataSource();

  useEffect(() => {
    if (user && !user.impersonator) {
      const data = {
        visitor: {
          id: user.id,
          roles: user.roles.map(r => r.name),
          accountRoles: customerAccess?.roles.map(r => r.name),
          dataSourceRoles: dataSourceAccess?.roles.map(r => r.name),
        },
        account: {
          id: customer?.id,
        },
      };

      window.pendo.initialize(data);
    }
  }, [user, customer, customerAccess, dataSourceAccess]);

  return null;
};

export default Pendo;
